import React from 'react';
import { IframeS } from './styles';

interface IframeForVideoProps {
  isFullScreen: boolean;
  link?: string;
  onLoad?: () => void;
}

export const IframeForVideo: React.FC<IframeForVideoProps> = React.memo(({ isFullScreen, link, onLoad }) => {
  return (
    <IframeS
      isFullScreen={isFullScreen}
      src={link}
      title="YouTube video player"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen={false}
      onLoad={onLoad}
    />
  );
});
